import { createContext, use } from "react";
import type { Organization } from "@/lib/data";

export const OrganizationContext = createContext<Organization | null>(null);

export function useOrganization() {
  const org = use(OrganizationContext);
  if (!org) {
    throw new Error("useOrganization must be used within OrganizationProvider");
  }
  return org;
}
